<template>
    <div>
        <validation-observer ref="checkboxForm">
            <validation-provider
                v-slot="{ errors }"
                :rules="question.mandatory && selected.length === 0 ? 'required' : ''"
            >
                <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                    <div v-if="question" class="checkbox-attribute">
                        <label :for="id" :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}">{{ question.question_text }}</label>
                        <div :class="{' col-md-9 col-xs-8' : isInquiry}">
                            <ul>
                                <li
                                    v-for="(option, index) of  question.options"
                                    :key="index"
                                    :class="{'selected': option && isSelected(option), 'new-inputs': true}"
                                    @click="onClick(option)"
                                >
                                    <span class="question-value">{{ option.option }}</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </div>
            </validation-provider>
            <div v-if="selected && selected.length > 0" v-for="(selectedItem, index) of selected">
                <input
                    type="hidden"
                    :id="id + '-' + selectedItem.id"
                    :name="name"
                    :value="selectedItem.id"
                />
            </div>
            <input type="hidden" :value="id" name="questions[]" />
        </validation-observer>
    </div>
</template>

<script>
import { EventBus } from "@/events/event-bus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormCheckbox",
    props: {
        value: {
            type: Object,
        },
        values: {
            type: Array, // Add a 'values' prop to provide checkbox values
            default: () => [],
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            question: {
                ...this.value,
            },
            selected: [],
        };
    },
    computed: {
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}[]`;
            }
            return `question_${this.question.update_booking_question_id}_0[]`;
        },
    },
    methods: {
        onClick(option) {
            if (this.selected.indexOf(option) > -1) {
                this.uncheck(option);
            } else {
                this.check(option);
            }

            if(this.viewPage && this.isInquiry){
                let selectedIds = [];
                this.selected.forEach(option => {
                    selectedIds.push(option.id)
                });
                updateFormQuestionOnViewInquiry(selectedIds, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }

            this.$emit("input", this.question);
        },
        uncheck(option) {
            // Remove the value from the selected array
            this.selected.splice(this.selected.indexOf(option), 1);
            this.question.value = null;
            this.question.value = this.selected;
            this.question.answer_text = null;
        },
        check(option) {
            // Add the value to the selected array
            this.selected.push(option);
            this.question.value = null;
            this.question.value = this.selected;
            this.question.answer_text = null;
        },
        retrieveSelected() {
            if (this.question.answer_text && this.selected) {
                this.question.options.forEach(option => {
                    if( this.question.answer_text.includes(option.id)){
                        this.selected.push(option);
                    }
                });
                return this.selected;
            }else if (this.question && this.selected) {
                return this.selected;
            }
            return this && Object.keys((this || {}).selected || {}) ? this.selected : {};
        },
        triggerChange() {
            EventBus.$emit("onFormsFieldUpdated", this.input.service_id, this.clone);
        },
        addEventListeners() {
            EventBus.$on("onFormsAndCheckListsValidation", async (verify) => {
                if(this.$refs.checkboxForm){
                    verify(await this.$refs.checkboxForm.validate());
                }

            });
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        isSelected(optionId) {
            if (this.question.answer_text) {
                return this.question.answer_text.includes(optionId.id);
            } else {
                return this.selected.includes(optionId);
            }
        },
    },
    mounted() {
        this.selected = this.retrieveSelected() || [];
        this.addEventListeners();
    },
    watch: {
        question: {
            handler(question) {
                this.$emit("input", question);
            },
            deep: true,
        },
    },
    destroyed() {
        this.removeEventListeners();
    }
};
</script>

<style scoped>
.selected {
    font-weight: bold;
}
.p-0-1{
    padding:0px 1px;
}
@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        margin-left: 15px !important;
    }
}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
        margin-left: 15px !important;
    }
}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        margin-left: 17px !important;
    }
}
</style>
